import { connect, useDispatch } from 'react-redux'
import PrescriptionForm from './PrescriptionForm'
import PrescriptionHeader from './PrescriptionHeader'
import PrescriptionActions from './PrescriptionActions'
import { reportCreate, reportEdit, reportReset, reportUpdate } from '../../../../redux/actions/reports/reportsActions'
import * as $ from 'jquery';
import { quickActionsReset } from '../../../../redux/actions/dashboard/quickActionActions'
import { reset } from 'redux-form'
import { examReset } from '../../../../redux/actions/exam/examActions'
import { useEffect } from 'react'

function Prescription(props) {
  const { prescription, examId } = props
  const dispatch = useDispatch()

  useEffect(() => {
    // handle prescription import info cases after coming from exam
    examId && dispatch(examReset())
  }, [])

  const handlePrescriptionSubmit = async (data) => {
    if (data.id) {
      if (!data.finalized_lenses_attributes.length && !data.finalized_glasses_attributes.length && data.close) {
        // delete prescription
        data = { ...data, check_empty_prescription: true }
      }
      await dispatch(reportUpdate(data, { include: '*' }))
    } else {
      await dispatch(reportCreate(data, { include: '*' }))
    }
    if (data.close) {
      handleReset()
    }
  }

  const handleResetData = () => {
    dispatch(reportReset())
    dispatch(quickActionsReset())
    dispatch(reportEdit({ showPrescriptionModal: false }))
  }

  const handleReset = () => {
    setTimeout(() => {
      $('#prescription-modal').modal('hide');
      handleResetData()
      dispatch(reset('PrescriptionForm'));
    }, 700);
  }

  return (
    <div>
      <PrescriptionHeader />
      {prescription.id && <PrescriptionActions prescription={prescription} />}
      <PrescriptionForm onSubmit={handlePrescriptionSubmit} />
    </div>
  )
}

const mapStateToProps = (state) => {
  const { reports: { report }, exam: { exam } } = state;
  return {
    prescription: report,
    examId: exam.id
  }
}

export default connect(mapStateToProps)(Prescription)